'use strict';

function AddSpendingController(
    $scope,
    $mdDialog,
    spendingsPromise
) {
    'ngInject';

    spendingsPromise.$promise.then((res) => {
        $scope.oSpendings = res.oSpendings;
    });

    $scope.btnDisabled = true;

    $scope.getSpendings = function() {
        return spendingsPromise;
    };

    $scope.save = function() {
        $mdDialog.hide({
            oSpending: this.selectedSpending
        });
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}

export default AddSpendingController;
